import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Layout.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';  // power icon

export default function TopBar() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [now, setNow] = React.useState(new Date());

  React.useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  // Format: 11 SEP 2025 | 23:07:01 (GMT+8)
  const months = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
  const day   = String(now.getDate()).padStart(2,'0');
  const month = months[now.getMonth()];
  const year  = now.getFullYear();
  const time  = now.toLocaleTimeString('en-GB', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
  const formatted = `${day} ${month} ${year} | ${time} (GMT+8)`;

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <header className="topbar">
      <div className="topbar-left">
        {/* Logo served from public/ folder */}
        <img className="logo" src="/spm-logo.png" alt="Company logo" />
      </div>

      <div className="topbar-title">
        SMART ILT MONITORING PLATFORM
      </div>

      <div className="topbar-right">
        <span className="clock">{formatted}</span>
        <button
          className="logout"
          title="Log out"
          onClick={handleLogout}
        >
          <FontAwesomeIcon icon={faPowerOff} size="2x" />
        </button>
      </div>
    </header>
  );
}